module.exports = __webpack_public_path__ + "img/logo.e7aa6e3.png";